/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

export class AgingReportTotals {
  currentBillingPeriod: number;
  thirtyDays: number;
  sixtyDays: number;
  ninetyDays: number;
  ninetyPlusDays: number;
  total: number;
}
